<template>
    <div>
        <CheckboxWithLabel @checkboxChange="checkboxChange">
            {{ TEXTS.render(`PRIVACY_STATEMENT_CHECKBOX`) }}
        </CheckboxWithLabel>
        <p class="mb-0" v-html="TEXTS.render(`PRIVACY_STATEMENT_SUBHEADER`, null, null, {skipCasing:true})">
        </p>
    </div>
</template>

<script>
    import CheckboxWithLabel from '../../../../common/components/CheckboxWithLabel'
    import Texts from '../../../../common/utils/Texts'

    export default {
        components :{
            CheckboxWithLabel
        },
        methods: {
            checkboxChange(checked) {
                this.$emit('onChange', checked);
            }
        },
        computed : {
            TEXTS : ()=> Texts,
        }
    }
</script>